import { ToothPeriodontal } from '../../../../graphql/graphql';
import {
	PeriodontalObject,
	PeriodontalSurface,
} from '../../Interfaces/PeriodontalObject.interface';

export function getPeriodontalObjectWithTitle(
	periodontal: ToothPeriodontal,
): Record<PeriodontalSurface, PeriodontalObject> {
	return {
		mesioPalatal: {
			item: periodontal.mesioPalatal,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.mesioPalatal',
			type: 'mesioPalatal',
		},
		palatal: {
			item: periodontal.palatal,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.palatal',
			type: 'palatal',
		},
		distoPalatal: {
			item: periodontal.distoPalatal,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.distoPalatal',
			type: 'distoPalatal',
		},
		mesioBuccal: {
			item: periodontal.mesioBuccal,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.mesioBuccal',
			type: 'mesioBuccal',
		},
		buccal: {
			item: periodontal.buccal,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.buccal',
			type: 'buccal',
		},
		distoBuccal: {
			item: periodontal.distoBuccal,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.distoBuccal',
			type: 'distoBuccal',
		},
		mesioLingual: {
			item: periodontal.mesioLingual,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.mesioLingual',
			type: 'mesioLingual',
		},
		lingual: {
			item: periodontal.lingual,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.lingual',
			type: 'lingual',
		},
		distoLingual: {
			item: periodontal.distoLingual,
			title: 'patientTreatment.meddiDENT.dentalCross.periodontal.distoLingual',
			type: 'distoLingual',
		},
	};
}
